import { autoinject } from 'aurelia-framework';
import { Connection } from 'models/Connections';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class ConnectionService extends BaseApiService<Connection> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, Connection);
  }
}
